import { StyleSheet } from 'react-native';

import { Colors, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    backgroundColor: Colors.transparent,
    height: 182,
    marginTop: 10,
    borderRadius: 6,
    marginRight: Metrics.galleryCardMargin,
    width: Metrics.galleryCardWidth,
    overflow: 'hidden',
  },
});
